const searchModules = {
  state: {
    jobFilter: null,
    companyFilter: null,
    resumeFilter: null,
  },
  getters: {
    jobFilter: state => state.jobFilter,
    companyFilter: state => state.companyFilter,
    resumeFilter: state => state.resumeFilter
  },
  mutations: {
    updateJobFilter (state, jobFilter) {
      state.jobFilter = jobFilter
      uni.$emit('updateJobFilter', jobFilter)
    },
    updateCompanyFilter (state, companyFilter) {
      state.companyFilter = companyFilter
      uni.$emit('updateCompanyFilter', companyFilter)
    },
    updateResumeFilter (state, resumeFilter) {
      state.resumeFilter = resumeFilter
      uni.$emit('updateResumeFilter', resumeFilter)
    }
  }
}

export default searchModules
